/* eslint max-len: 0 */
import React from "react";
import PropTypes from "prop-types";
import styles from "./Star.css";
import classnames from "classnames";

// Gradient def for half filled star is only rendered once, typically in
// main body template. We use this ID to link them
// If the <StarGradient /> component has not been rendered on the page stars
// will not render properly!
import { LMN_HALF_STAR_ID, HALF_STAR_ID } from "./StarGradient";

function getStarFill (filled, isLMN) {
  if (filled === "half") {
    return isLMN ?
      `url(#${LMN_HALF_STAR_ID})` :
      `url(#${HALF_STAR_ID})`;
  } else if (filled === "full") {
    return isLMN ? "#FFB700" : "#CCBB66";
  } else {
    return "#DCDCDF";
  }
}

const Star = ({ type, filled = "empty", isLMN = false }) => {
  const starClasses = classnames(styles.star, {
    [styles.starLMN]: isLMN,
    [styles.big]: type === "big",
    [styles.medium]: type === "medium",
    [styles.small]: type === "small"
  });

  const fill = getStarFill(filled, isLMN);

  return (
    <svg viewBox="0 0 20 20" className={starClasses}>
      <g>
        <path fill={fill} d="M10,13.8 L5.74385605,16.9065054 C4.84821114,17.5602253 4.39973843,17.2421442 4.74674382,16.182061 L6.38598528,11.1742646 L2.12395237,8.15168598 C1.22706821,7.51562734 1.38980042,6.99999993 2.50986227,6.99999993 L7.99999982,6.99999994 L9.44819687,1.93131077 C9.75294932,0.864677285 10.2452392,0.858337419 10.551803,1.93131082 L11.9999997,7.00000013 L17.490138,7.00000013 C18.6001545,7.00000013 18.7664375,7.52023356 17.8760481,8.15168612 L13.6140147,11.1742646 L15.2532562,16.182061 C15.5982112,17.2358805 15.1571124,17.5641109 14.256144,16.9065054 L10,13.8 Z"/>
      </g>
    </svg>
  );
};

Star.propTypes = {
  type: PropTypes.string,
  filled: PropTypes.string,
  isLMN: PropTypes.bool
};

export default Star;
